export const PlayCircleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.42375 6.64125L5.92375 4.45375C5.85429 4.40517 5.77222 4.37781 5.6875 4.375C5.44588 4.375 5.25 4.57088 5.25 4.8125V9.1875C5.25 9.42912 5.44588 9.625 5.6875 9.625C5.76941 9.62526 5.84975 9.60253 5.91937 9.55937L9.41937 7.37188C9.5427 7.29167 9.61745 7.15485 9.61833 7.00774C9.61922 6.86063 9.5461 6.72293 9.42375 6.64125ZM6.125 5.60875L8.3475 7L6.125 8.39125V5.60875Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0.875C3.61726 0.875 0.875 3.61726 0.875 7C0.875 10.3827 3.61726 13.125 7 13.125C10.3827 13.125 13.125 10.3827 13.125 7C13.125 5.37555 12.4797 3.81763 11.331 2.66897C10.1824 1.52031 8.62445 0.875 7 0.875ZM7 12.25C4.10051 12.25 1.75 9.8995 1.75 7C1.75 4.10051 4.10051 1.75 7 1.75C9.8995 1.75 12.25 4.10051 12.25 7C12.25 8.39239 11.6969 9.72774 10.7123 10.7123C9.72774 11.6969 8.39239 12.25 7 12.25Z"
      fill="currentColor"
    />
  </svg>
);
